function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaiwanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_762",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_762)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#EF0000"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_762",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_762)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V13.5H13.5V3H0Z",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.54725 11.1081L5.436 12.4945L5.16683 10.7382L3.51127 11.3832L4.15629 9.72766L2.40002 9.45849L3.78641 8.34725L2.40002 7.236L4.15629 6.96683L3.51127 5.31127L5.16683 5.95629L5.436 4.20002L6.54725 5.58641L7.65849 4.20002L7.92767 5.95629L9.58322 5.31127L8.9382 6.96683L10.6945 7.236L9.30808 8.34725L10.6945 9.45849L8.9382 9.72766L9.58322 11.3832L7.92767 10.7382L7.65849 12.4945L6.54725 11.1081ZM6.54725 10.494C7.73287 10.494 8.69401 9.53286 8.69401 8.34723C8.69401 7.16161 7.73287 6.20047 6.54725 6.20047C5.36163 6.20047 4.40049 7.16161 4.40049 8.34723C4.40049 9.53286 5.36163 10.494 6.54725 10.494ZM8.26465 8.34725C8.26465 9.29574 7.49574 10.0647 6.54725 10.0647C5.59875 10.0647 4.82984 9.29574 4.82984 8.34725C4.82984 7.39875 5.59875 6.62984 6.54725 6.62984C7.49574 6.62984 8.26465 7.39875 8.26465 8.34725Z",
        fill: "#FEFFFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Taiwan.js.map